import DocumentTabModule from "components/Modules/Documents/DocumentTabModule"
import { withRouter } from "react-router-dom"
import CityBudgetEarnings from "./_tabs/CityBudgetEarnings"
import CityBudgetExpenses from "./_tabs/CityBudgetExpenses"
import CityBudgetFiles from "./_tabs/CityBudgetFiles"
import CityBudgetSettings from "./_tabs/CityBudgetSettings"

const CityBudget = () => {
  return (
    <DocumentTabModule
      tabs={[
        {
          label: "Earnings",
          Component: () => <CityBudgetEarnings />,
        },
        {
          label: "Expenses",
          Component: () => <CityBudgetExpenses />,
        },
        {
          label: "Files",
          Component: () => <CityBudgetFiles />,
        },
        {
          label: "Settings",
          Component: () => <CityBudgetSettings />,
        },
      ]}
      opened={"136"}
    />
  )
}

export default withRouter(CityBudget)
